/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import OTPInput, { ResendOTP } from "otp-input-react";
import { matchOTP } from '../master/api';



/*
  Virification Component
  Props:
    - returnFunction: Callback function to execute after successful verification (default: null)
    - mobile: Mobile number to verify
    - closePOup: Function to close the popup/modal
  Renders an OTP input form for mobile verification, handles OTP submission, status display, and resend functionality.
*/
export function Virification({ returnFunction = null, mobile, closePOup }) {
  // State for loading indicator during OTP verification
  const [loading, setLoading] = useState(false)
  // State for storing the entered OTP value
  const [OTP, setOTP] = useState("");
  // State for status message (success/error)
  const [status, setStatus] = useState('');

  /*
    Handles OTP form submission.
    - Prevents default form behavior
    - Sets loading state
    - Calls matchOTP API to verify OTP
    - Updates status and loading states based on response
    - Calls returnFunction on success or failure if provided
  */
  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true)
    setTimeout(() => {
      matchOTP({ mobile: mobile, otp: OTP }).then(({ data }) => {
        if (Number(data.code) === 0) {
          setStatus(data?.message);
          setLoading(false)
          if (returnFunction) {
            // returnFunction(1)
          }
        } else {
          if (returnFunction) {
            returnFunction(1)
          }
          setStatus(data?.message);
        }
      }).catch(() => {
        setLoading(false)
        setStatus('Something wrong!')
      })
    }, 1000)

  }
  return (
    <>
      <div className="mx-auto">
        <form
          className='form w-100'
          onSubmit={handleSubmit}
          noValidate
        >
          <div className="text-center mb-3">
            {/* begin::Title */}
            <h1 className="text-dark mb-3">Verification</h1>
            {/* end::Title */}
            {/* begin::Sub-title */}
            <div className="text-muted fw-semibold fs-5 mb-5">Enter the verification code we sent to</div>
            {/* end::Sub-title */}
            {/* begin::Mobile no */}
            <div className="fw-semibolder text-dark fs-3">{mobile.replace(/.(?=.{4})/g, '*')}</div>
            {/* end::Mobile no */}
            {status !== "" &&
              <div className="text-danger fw-semibold fs-5 mb-5">{status}</div>

            }
          </div>
          <div className="mb-10 px-md-10">
            {/* begin::Label */}
            <div className="fw-semibolder text-start text-dark fs-6 mb-1 ms-1">Type your 4 digit otp code</div>
            {/* end::Label */}
            {/* begin::Input group */}
            <div className="d-flex flex-wrap flex-stack">
              <OTPInput
                value={OTP} onChange={setOTP}
                inputClassName={`form-control form-control-solid  h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2`}
                autoFocus OTPLength={4}
                otpType="number"
                disabled={false} />

            </div>
            {/*begin::Input group*/}
          </div>
          {/* begin::Heading */}


          {/* begin::Action */}
          <div className='text-center'>
            <div className='d-flex flex-stack'>
              <button
                type='button'
                id='kt_cancell_in_submit'
                className='btn btn-lg w-100 mb-5 me-3'
                style={{ background: '#0E295E' }}
                //disabled={loading}
                onClick={() => closePOup()}
              >
                <span className='indicator-label text-white'>Cancel</span>
              </button>
              <button
                type='submit'
                id='kt_otp_in_submit'
                className='btn btn-lg btn-primary w-100 mb-5'
                disabled={!OTP}
              >
                {!loading && <span className='indicator-label'>Continue</span>}
                {loading && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            <div className="text-center fw-semibold fs-5">
              <span className="text-muted me-1">Didn’t get the code ?</span>
              <a href="#" onClick={() => ResendOTP()} className="link-primary fw-semibolder fs-5 me-1">Resend</a>

            </div>
          </div>


        </form>


      </div>

    </>
  )
}
